/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');

const FixHeight = require('./../../../../services/fixHeight');
const Mediator = require('./../../../../core/mediator');
const Translator = require('./../../../../core/translator');
const Zone = require('./../../../../services/structure/zone');
const FormBuilder = require('./../../../../services/form');
const Loader = require('./../../../../services/loader');

const PageRepository = require('./../../repository/page');
const LangRepository = require('./../../../user/repository/LangRepository');
const TagRepository = require('./../../../tag/repository/TagRepository');

const TableTpl = require('./template/table.hbs');
const ItemTpl = require('./template/item.hbs');
const PaginationTpl = require('./template/pagination.hbs');
const HeaderTpl = require('./template/header.hbs');
const ByPageTpl = require('./template/by_page.hbs');

let $table;
let $header;

let storageSearchData = window.localStorage.getItem('bb-search-data');
let searchData = storageSearchData ? JSON.parse(storageSearchData) : {};
let sortArray = [];
let langActivated = false;
let categoryActivated = false;
let defaultByPage = 100;

module.exports.beforeShowFormAuth = () => {
  window.localStorage.removeItem('bb-search-data');
};

module.exports.init = () => {
  initSmallPanel();
};

const getTags = (tagsUid) => {
  return Promise.all(tagsUid.reduce((acc, value) => {
    acc.push(TagRepository.find(value));
    return acc;
  }, []));
};

const initSmallPanel = () => {
  let $container = jQuery('<div />');

  Loader.start($container);

  LangRepository.findAll('search').done((languages) => {
    PageRepository.getTypes('search').done((pageTypes) => {
      PageRepository.getCategories().done((pageCategories) => {
        getTags(searchData.tags ? searchData.tags.split(',') : []).then((searchTags) => {
          langActivated = !!languages.find((lang) => {
            return lang.is_active === true;
          });
          categoryActivated = pageCategories.length > 0;
          let formConfig = {
            elements: {
              'title': {
                type: 'text',
                placeholder: Translator.translate('search_page_title'),
                value: searchData.title || '',
                group: {
                  id: 'title',
                  title: Translator.translate('search_page_title'),
                },
              },
              'search_in': {
                inline: true,
                type: 'radio',
                options: {
                  'title': Translator.translate('search_page_search_in_title'),
                  'content': Translator.translate('search_page_search_in_content'),
                },
                value: searchData['search_in'] || 'title',
                group: {
                  id: 'search',
                },
              },
              'search_by_term': {
                inline: true,
                type: 'radio',
                options: {
                  'all_term': Translator.translate('search_page_search_by_term_all_term'),
                  'one_of_term': Translator.translate('search_page_search_by_term_one_of_term'),
                  'exact_term': Translator.translate('search_page_search_by_term_exact_term'),
                },
                value: searchData['search_by_term'] || 'all_term',
                group: {
                  id: 'search',
                },
              },
              'has_draft_only': {
                type: 'switch',
                label: Translator.translate('show_only_no_saved_pages'),
                labelIcon: '<i class="icon is-drafted icon-page-edit ml-1 brand-color"></i>',
                value: !!searchData['has_draft_only'],
                group: {
                  id: 'has_draft_only',
                },
              },
              'created_at': {
                'label': Translator.translate('search_page_created_at_label'),
                'type': 'datetimepicker',
                'placeholder': Translator.translate('search_page_created_at_placeholder'),
                'range': true,
                'enable_time': false,
                'value': searchData.created_at || null,
                'position': 'above',
                'group': {
                  id: 'filter_by_date',
                  title: Translator.translate('search_page_date_group_title'),
                },
                'wrap_class': 'input-group cloud-group cloud-datetimepicker',
                'label_class': 'cloud-label',
                'element_class': 'cloud-control form-control',
              },
              'modified_at': {
                'label': Translator.translate('search_page_modified_at_label'),
                'type': 'datetimepicker',
                'placeholder': Translator.translate('search_page_modified_at_placeholder'),
                'range': true,
                'enable_time': false,
                'value': searchData.modified_at || null,
                'position': 'above',
                'group': {
                  id: 'filter_by_date',
                },
                'wrap_class': 'input-group cloud-group cloud-datetimepicker',
                'label_class': 'cloud-label',
                'element_class': 'cloud-control form-control',
              },
              'published_at': {
                'label': Translator.translate('search_page_published_at_label'),
                'type': 'datetimepicker',
                'placeholder': Translator.translate('search_page_published_at_placeholder'),
                'range': true,
                'enable_time': false,
                'value': searchData.published_at || null,
                'position': 'above',
                'group': {
                  id: 'filter_by_date',
                },
                'wrap_class': 'input-group cloud-group cloud-datetimepicker',
                'label_class': 'cloud-label',
                'element_class': 'cloud-control form-control',
              },
              'lang': {
                type: 'select',
                options: (function() {
                  return languages
                    .filter((lang) => lang['is_active'])
                    .reduce(
                      (options, lang) => {
                        options[lang.id] = Translator.translate(`new_page_${lang.id}`);
                        return options;
                      },
                      {all: Translator.translate('all_langs')},
                    );
                })(),
                value: searchData.lang || 'all',
                group: {
                  id: 'filter',
                  title: Translator.translate('filters'),
                },
              },
              'is_online': {
                type: 'select',
                options: {
                  'all': Translator.translate('all_status'),
                  '1': Translator.translate('online'),
                  '0': Translator.translate('offline'),
                },
                value: searchData['is_online'] || 'all',
                group: {
                  id: 'filter',
                  title: Translator.translate('filters'),
                },
              },
              'type': {
                type: 'select',
                options: (function() {
                  return pageTypes.reduce(
                    (options, pageType) => {
                      options[pageType['unique_name']] =
                        Translator.translate(`page_type_${pageType['unique_name']}`) ===
                        `page_type_${pageType['unique_name']}`
                          ? `new_page_${pageType['unique_name']}`
                          : `page_type_${pageType['unique_name']}`;
                      return options;
                    },
                    {all: Translator.translate('all_page_types')},
                  );
                })(),
                value: searchData.type || 'all',
                group: {
                  id: 'filter',
                },
              },
              'category': {
                type: 'select',
                options: (function() {
                  return pageCategories.reduce(
                    (options, pageCategory) => {
                      options[pageCategory] = Translator.translate(`page_category_${pageCategory}`);
                      return options;
                    },
                    {
                      all: Translator.translate('all_page_categories'),
                      none: Translator.translate('none_page_categories'),
                    },
                  );
                })(),
                value: searchData.category || 'all',
                group: {
                  id: 'filter',
                },
              },
              'tags': {
                type: 'selectTag',
                placeholder: Translator.translate('filter_by_tags'),
                value: searchTags ? searchTags.map((tag) => ({id: tag.uid, label: tag.keyword})) : [],
                group: {
                  id: 'filter',
                },
              },
            },
            form: {
              'submit_class': 'd-none',
            },
          };

          if (!langActivated) {
            delete formConfig.elements.lang;
          }

          if (!categoryActivated) {
            delete formConfig.elements.category;
          }

          Mediator.publish('before:render:search-form', formConfig);

          let form = FormBuilder.getForm(formConfig);
          let $buttons;

          form.on('submit', (data) => {
            data['by_page'] = jQuery(ByPageTpl).find('select[name="by_page"] option:selected').val() || defaultByPage;
            computeSearch(data);
            doSearch();
          });

          $buttons = Zone.createSubmitButtons({
            onSubmitClick: form.submit.bind(form),
            noCancelBtn: true,
            submitLabel: 'search',
          });

          const addCleanFiltersBtn = () => {
            let $cleanFilters = jQuery(`<a class="setting-link mb-2" href="#">${Translator.translate('clean_filters')}</a>`);

            $cleanFilters.on('click', function(e) {
              e.preventDefault();

              if (form.elements.category) {
                form.elements.category.config.value = 'all';
              }
              if (form.elements['has_draft_only']) {
                form.elements['has_draft_only'].config.value = false;
              }
              if (form.elements['is_online']) {
                form.elements['is_online'].config.value = 'all';
              }
              if (form.elements['lang']) {
                form.elements['lang'].config.value = 'all';
              }
              if (form.elements['tags']) {
                form.elements['tags'].config.value = [];
              }
              if (form.elements['title']) {
                form.elements['title'].config.value = '';
              }
              if (form.elements['type']) {
                form.elements['type'].config.value = 'all';
              }
              if (form.elements['created_at']) {
                form.elements['created_at'].value = null;
              }
              if (form.elements['modified_at']) {
                form.elements['modified_at'].value = null;
              }
              if (form.elements['published_at']) {
                form.elements['published_at'].value = null;
              }

              $table.find('th').removeClass('asc desc');

              form.reset();

              searchData = {
                'by_page': jQuery(ByPageTpl).find('select[name="by_page"] option:selected').val() || defaultByPage,
              };
              sortArray = [];

              doSearch();

              addCleanFiltersBtn();
            });

            $container.find('.element_title').prepend($cleanFilters);
          };

          Loader.stop($container);

          $container.append(form.render());

          addCleanFiltersBtn();

          Zone.setFooter($container.parent('div'), $buttons);

          FixHeight.fix($container.parent('div'), jQuery(window).height() - 100 - $container.parent('div').find('.cloud-panel-footer').outerHeight());

          initFullPanel(() => {
            form.submit();
          });
        });
      });
    });
  });

  Zone.setSmallPanel(Translator.translate('search_page'), $container);
};

const cleanSearch = () => {
  searchData = {};
  sortArray = [];
  storeSearchData();
};

const storeSearchData = () => {
  window.localStorage.setItem('bb-search-data', JSON.stringify(searchData));
};

const computeSearch = (data) => {
  cleanSearch();
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      let value = data[key];

      if (value && value !== 'all') {
        if (key === 'has_draft_only') {
          searchData[key] = '1';
        } else if (key === 'tags') {
          if (value.length) {
            searchData[key] = value.map((tag) => tag.uid).join(',');
          }
        } else {
          searchData[key] = value;
        }
      }
    }
  }
};

const cleanTable = () => {
  $table.find('tr:not(:first)').remove();
  $table
    .parent()
    .find('.cloud-nav')
    .remove();
  $table
    .parent()
    .find('.count-page')
    .remove();
};

const insertItem = (item) => {
  item.statusLabel = Translator.translate(item.is_online ? 'online' : 'offline');
  item.pageTypeLabel = Translator.translate(
    Translator.translate(`page_type_${item.type}`) === `page_type_${item.type}`
      ? `new_page_${item.type}`
      : `page_type_${item.type}`,
  );
  item.pageCategoryLabel = categoryActivated
    ? Translator.translate(item.category ? `page_category_${item.category}` : 'none')
    : false;
  item.langLabel = langActivated ? item.lang.toUpperCase() : false;
  item.modifiedLabel = new Date(item.modified).toLocaleDateString(Translator.getTimezone());
  item.publishedLabel = item.published_at ? new Date(item.published_at).toLocaleDateString(Translator.getTimezone()) : '';
  item.createdLabel = item.created_at ? new Date(item.created_at).toLocaleDateString(Translator.getTimezone()) : '';

  let $item = jQuery(ItemTpl(item));

  $table.find('tbody').append($item);
};

const getContentRangeData = (contentRange) => {
  let data = /^(.*)-(.*)\/(.*)/.exec(contentRange);

  return {
    start: parseInt(data[1], 10),
    end: parseInt(data[2], 10),
    total: parseInt(data[3], 10),
  };
};

const getItemPerPageData = (acceptRange) => {
  let data = acceptRange.split(' ');

  return parseInt(data[1]);
};

const doSearch = () => {
  Loader.start($table);
  storeSearchData();
  PageRepository.get(searchData).done((pages, response) => {
    $table[pages.length ? 'removeClass' : 'addClass']('d-none');

    $table.siblings('.no-result').remove();

    cleanTable();

    if (!pages.length) {
      jQuery(`<p class="no-result">${Translator.translate('search_page_no_result')}</p>`).insertBefore($table);
      $header.find('.header-by-page').html('');
    } else {
      generatePagination(response);
      generateCount(response);
      generateByPage(response);
    }

    Loader.stop($table);

    pages.forEach((page) => {
      insertItem(page);
    });
  });
};

const generatePagination = (response) => {
  let rangeData = getContentRangeData(response.headers['content-range']);
  let byPage = getItemPerPageData(response.headers['accept-range']);
  let config = {
    hasFirst: rangeData.start > 0,
    hasLast: rangeData.end + 1 < rangeData.total,
  };
  let $pagination = jQuery(
    PaginationTpl(config),
  );

  if (!config.hasFirst && !config.hasLast) {
    $pagination.find('.page-item').addClass('d-none');
  }

  $pagination.find('a.prev').on('click', function(e) {
    let begin = rangeData.start - byPage;
    e.preventDefault();
    searchData['range'] = `${begin > 0 ? begin : 0}-${rangeData.start - 1}`;
    doSearch();
  });

  $pagination.find('a.next').on('click', function(e) {
    e.preventDefault();
    searchData['range'] = `${rangeData.end + 1}-${byPage + rangeData.end}`;
    doSearch();
  });

  $header.find('.header-pagination').append($pagination);
};

const generateCount = (response) => {
  let rangeData = getContentRangeData(response.headers['content-range']);
  let $content = jQuery(
    `<p class="count-page mb-0 pt-3">${Translator.translate('page_count', {
      nb: rangeData.total,
    })}</p>`,
  );
  $header.find('.header-count').append($content);
};

const generateByPage = (response) => {
  let byPage = getItemPerPageData(response.headers['accept-range']);
  let $byPageTpl = jQuery(ByPageTpl({
    'label': Translator.translate('search_by_page'),
    'byPage': byPage,
    'values': [50, 100, 200],
  }));
  let $select = $byPageTpl.find('select[name="by_page"]');

  $select.on('change', function(e) {
    e.preventDefault();
    searchData['by_page'] = this.value;
    doSearch();
  });

  if ($header.find('.header-by-page .by-page').length === 0) {
    $header.find('.header-by-page').append($byPageTpl);
  }
};

const onSortClick = function() {
  let $th = jQuery(this);

  $th.parent('tr').children().not($th).removeClass('asc desc');

  if ($th.hasClass('asc')) {
    $th.addClass('desc').removeClass('asc');
  } else if ($th.hasClass('desc')) {
    $th.addClass('asc').removeClass('desc');
  } else {
    $th.addClass('asc');
  }

  let sortName = $th.data('sort');
  let direction = $th.hasClass('asc') ? 'asc' : 'desc';

  sortArray[sortName] = direction;

  searchData.sort = `${sortName}:${direction}`;

  delete searchData['range'];

  doSearch();
};

const initFullPanel = (callback) => {
  let $container = jQuery('<div class="mt-3" />');

  $header = jQuery(HeaderTpl());
  $table = jQuery(TableTpl({langActivated, categoryActivated}));

  $table.find('th').on('click', onSortClick);

  $container.append($header);
  $container.append($table);

  callback();

  Zone.setFullPanel(Translator.translate('search_page_result'), $container);
};
